import { render } from "./MainIllustration.vue?vue&type=template&id=68f30a84"
import script from "./MainIllustration.vue?vue&type=script&lang=js"
export * from "./MainIllustration.vue?vue&type=script&lang=js"

import "./MainIllustration.vue?vue&type=style&index=0&id=68f30a84&lang=css"
script.render = render

export default script